import React from 'react';
import './Badge.css';

const Badge = ({ 
  children, 
  variant = 'default',
  size = 'sm',
  rounded = true,
  className = '',
  icon: Icon,
  dot = false,
  pill = false,
  shimmer = false,
  ...props 
}) => {
  const variants = {
    default: 'badge-default bg-[#F1F5F9] text-[#64748B] border-[#E2E8F0]',
    success: 'badge-success bg-emerald-50 text-emerald-700 border-emerald-200',
    warning: 'badge-warning bg-amber-50 text-amber-700 border-amber-200',
    danger: 'badge-danger bg-red-50 text-red-700 border-red-200',
    info: 'badge-info bg-blue-50 text-blue-700 border-blue-200',
    // purple removed
    // purple: 'badge-purple bg-purple-50 text-purple-700 border-purple-200', // ❌ REMOVED
    whatsapp: 'badge-whatsapp bg-[#25D366]/10 text-[#128C7E] border-[#25D366]/20',
    dark: 'badge-dark bg-[#0F172A] text-white border-[#1E293B]',
    pink: 'badge-pink bg-pink-50 text-pink-700 border-pink-200',
    indigo: 'badge-indigo bg-indigo-50 text-indigo-700 border-indigo-200',
    gradient: 'badge-gradient bg-gradient-to-r from-[#2563EB] to-[#1D4ED8] text-white border-transparent' // changed to blue only
  };

  const sizes = {
    xs: 'px-2 py-0.5 text-[10px] gap-1',
    sm: 'px-2.5 py-0.5 text-xs gap-1.5',
    md: 'px-3.5 py-1 text-sm gap-1.5',
    lg: 'px-4.5 py-1.5 text-base gap-2'
  };

  const roundedClass = rounded ? (pill ? 'rounded-full' : 'rounded-lg') : '';
  const dotClass = dot ? 'badge-dot' : '';
  const shimmerClass = shimmer ? 'badge-shimmer' : '';

  return (
    <span 
      className={`badge inline-flex items-center font-medium border ${variants[variant]} ${sizes[size]} ${roundedClass} ${dotClass} ${shimmerClass} ${className}`}
      {...props}
    >
      {Icon && <Icon className="w-3 h-3 flex-shrink-0" />}
      {children}
    </span>
  );
};

export default Badge;